"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trace = exports.SpanStatusCode = exports.context = void 0;
exports.getMeter = getMeter;
exports.getTracer = getTracer;
exports.withSpan = withSpan;
const api_1 = require("@opentelemetry/api");
var api_2 = require("@opentelemetry/api");
Object.defineProperty(exports, "context", { enumerable: true, get: function () { return api_2.context; } });
Object.defineProperty(exports, "SpanStatusCode", { enumerable: true, get: function () { return api_2.SpanStatusCode; } });
Object.defineProperty(exports, "trace", { enumerable: true, get: function () { return api_2.trace; } });
function getMeter(name) {
    return api_1.metrics.getMeter(name || 'default');
}
function getTracer(name) {
    return api_1.trace.getTracer(name || 'default');
}
async function withSpan(name, fn, tracerName) {
    const tracer = getTracer(tracerName);
    return tracer.startActiveSpan(name, async (span) => {
        try {
            return await fn(span);
        }
        catch (err) {
            span.recordException(err);
            span.setStatus({
                code: api_1.SpanStatusCode.ERROR,
                message: err instanceof Error ? err.message : String(err),
            });
            throw err;
        }
        finally {
            span.end();
        }
    });
}
